export enum OrderTypeIdEnum {
  priced = 1,
  stopLimit = 2,
  market = 3,
}
